import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useEffect } from "react";
import ComponentHeader from "./components/header";
import ComponentFooter from "./components/footer";
import { SectionBook } from "./SectionBook";

export default function Book() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout className="!bg-transparent">
      <ComponentHeader />
      <Content className="min-h-[70vh]">
        <SectionBook />
      </Content>
      <ComponentFooter />
    </Layout>
  );
}
